export const reportCardList_style = {};
